module.exports = __webpack_public_path__ + "img/host4-sm.61819bfa.png";